<template>
  <!-- 登录 -->
  <el-dialog ref="dialog" :visible.sync="centerDialogVisible" :lock-scroll="false" width="30%" center :show-close="false">
    <div class="content">
      <div class="register">
        <div>登录</div>
        <div @click="centerDialogVisible = false">×</div>
      </div>
      <!-- <div style="color: #a9aeb8; line-height: 2; margin-bottom: 8px">
        国家知识产权国际运营平台
      </div> -->
      <!-- 手机邮箱注册切换 -->
      <div class="switch">
        <div class="regis">
          <el-tabs v-model="editableTabsValue" @tab-click="changeTab">
            <!-- 手机注册 -->
            <el-tab-pane label="短信登录">
              <el-form :model="dynamicValidateFormmobile" ref="dynamicValidateFormmobile" class="demo-dynamic">
                <!-- 手机号 -->
                <div>
                  <div class="email">手机号</div>
                  <el-form-item prop="mobile" :rules="rules.mobile">
                    <el-input type="tel" maxlength="11" placeholder="请输入手机号"
                      v-model="dynamicValidateFormmobile.mobile"></el-input>
                  </el-form-item>
                </div>
                <!-- 图形验证码 -->
                <div>
                  <div class="email">图形验证码</div>
                  <el-form-item prop="captcha">
                    <div style="display: flex;">
                      <el-input type="tel" maxlength="11" placeholder="请输入验证码"
                        v-model="dynamicValidateFormmobile.captcha">
                      </el-input>
                      <img :src="baseUrl + '/security/captcha'" alt="captcha" style="margin-left: 8px;cursor: pointer;"
                        @click="getCaptcha()" ref="captcha1">
                    </div>


                  </el-form-item>
                </div>
                <!-- 验证码 -->
                <div>
                  <div class="email">验证码</div>
                  <div>
                    <el-form-item prop="mobilein" :rules="rules.mobilein">
                      <el-input placeholder="输入4位验证码" maxlength="4" v-model="dynamicValidateFormmobile.mobilein">
                        <template slot="append">
                          <span style="margin-right: 14px; color: #c9cdd4">|</span>
                          <el-button @click="sendOutCode()" type="primary" :disabled="judge || !dynamicValidateFormmobile.mobile
                            ">{{ countdown }}</el-button>
                        </template>
                      </el-input>
                    </el-form-item>
                  </div>
                </div>
                <!-- 阅读 -->
                <div class="check newcheck">
                  <el-checkbox v-model="checkPhone"> 保持登录 </el-checkbox>
                </div>
              </el-form>
              <!-- 注册   :disabled="
                                    judge ||
                                    !dynamicValidateFormmobile.mobilepass ||
                                    !dynamicValidateFormmobile.mobilein ||
                                    !dynamicValidateFormmobile.mobile
                                "-->
              <el-button style="width: 100%" type="primary" :disabled="disBtn"
                @click="submitForm('dynamicValidateFormmobile')">
                登录</el-button>
              <div class="go">
                还没有账号？<span @click="registerChange" style="color: #165dff">去注册</span>
              </div>
            </el-tab-pane>

            <!-- 邮箱注册 -->
            <el-tab-pane label="密码登录">
              <el-form :model="dynamicValidateForm" ref="dynamicValidateForm" class="demo-dynamic">
                <!-- 邮箱 -->
                <div>
                  <div class="email">手机号/邮箱</div>
                  <el-form-item prop="email">
                    <el-input placeholder="请输入手机号或邮箱" v-model="dynamicValidateForm.phoneEmail"></el-input>
                  </el-form-item>
                </div>
                <!-- 密码 -->
                <div>
                  <div class="forget">
                    <div class="email">密码</div>
                    <div class="forget-pass" @click="changePassword">
                      忘记密码?
                    </div>
                  </div>
                  <div>
                    <el-form-item prop="pass" :rules="rules.mobilepass">
                      <el-input type="password" placeholder="请输入密码" v-model="dynamicValidateForm.pass"
                        autocomplete="off"></el-input>
                    </el-form-item>
                  </div>
                </div>
                <!-- 图形验证码 -->
                <div>
                  <div class="email">图形验证码</div>
                  <el-form-item prop="captcha">
                    <div style="display: flex;">
                      <el-input type="tel" maxlength="11" placeholder="请输入验证码"
                        v-model="dynamicValidateFormmobile.captcha">
                      </el-input>
                      <img :src="baseUrl + '/security/captcha'" alt="captcha" style="margin-left: 8px;cursor: pointer;"
                        @click="getCaptcha()" ref="captcha2">
                    </div>


                  </el-form-item>
                </div>
                <!-- 阅读 -->
                <div class="check newcheck">
                  <el-checkbox v-model="checkLogin"> 保持登录 </el-checkbox>
                </div>
              </el-form>
              <el-button style="width: 100%" type="primary" :disabled="disBtn" @click="submitForm('dynamicValidateForm')">
                登录</el-button>
              <div class="go">
                还没有账号？<span @click="registerChange" style="color: #165dff">去注册</span>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { postRequest } from "../api/api";
import { setJWT, setUSER, baseUrl } from "../api/constant";

import {
  Dialog,
  Tabs,
  TabPane,
  Form,
  FormItem,
  Button,
  Input,
  Checkbox,
} from "element-ui";
import Vue from "vue";

Vue.use(Button);
Vue.use(Dialog);
Vue.use(Tabs);
Vue.use(TabPane);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Input);
Vue.use(Checkbox);

let timer = "";

export default {
  data() {
    const validatePhone = (rule, value, callback) => {
      const reg =
        /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
      if (value.length === 0) {
        callback(new Error("请输入手机号"));
      } else if (value.length !== 11 || !reg.test(value)) {
        callback(new Error("请输入正确的手机号"));
      } else {
        callback();
      }
    };
    const validateMobilein = (rule, value, callback) => {
      if (value.length === 0) {
        callback(new Error("请输入验证码"));
      } else if (value.length !== 4) {
        callback(new Error("验证码错误"));
      } else {
        callback();
      }
    };
    const validatePassword = (rule, value, callback) => {
      if (value.length === 0) {
        callback(new Error("请输入密码"));
      }
      // else if (value.length < 8) {
      //   callback(new Error("请输入至少8位数密码"));
      // }
      else {
        callback();
      }
    };
    const validatEmail = (rule, value, callback) => {
      const reg = /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
      if (value.length === 0) {
        callback(new Error("请输入邮箱"));
      } else if (!reg.test(value)) {
        callback(new Error("请输入正确的邮箱"));
      } else {
        callback();
      }
    };
    return {
      baseUrl,
      centerDialogVisible: false,
      editableTabsValue: "0",
      rules: {
        mobile: [
          {
            required: true,
            validator: validatePhone,
            trigger: "blur",
          },
        ],
        mobilein: [
          {
            required: true,
            validator: validateMobilein,
            trigger: "blur",
          },
        ],
        mobilepass: [
          {
            required: true,
            validator: validatePassword,
            trigger: "blur",
          },
        ],
        email: [
          {
            required: true,
            validator: validatEmail,
            trigger: "blur",
          },
        ]
      },
      visible: true,
      checkLogin: false,
      checkPhone: false,
      checked: false, //单选按钮
      radio: false,
      judge: false, //禁用按钮
      countdown: "发送验证码", //验证码倒计时
      dynamicValidateForm: {
        email: "", //邮箱
        pass: "", //请输入密码
        input2: "", //邮箱验证码
        captcha: ""
      },
      dynamicValidateFormmobile: {
        mobile: "", //手机号
        mobilepass: "", //请输入密码
        mobilein: "", //手机验证码
        captcha: ""
      },
    };
  },
  computed: {
    disBtn() {
      if (this.editableTabsValue == "1") {
        return !(
          this.dynamicValidateForm.pass && this.dynamicValidateForm.phoneEmail
        );
      } else if (this.editableTabsValue == "0") {
        return !(
          this.dynamicValidateFormmobile.mobilein &&
          this.dynamicValidateFormmobile.mobile
        );
      }
    },
  },
  methods: {
    // 更新图形验证码
    getCaptcha() {
      this.$refs.captcha1.src = baseUrl + '/security/captcha'
      this.$refs.captcha2.src = baseUrl + '/security/captcha'
    },
    // 打开忘记密码弹窗，关闭登录弹框
    changePassword() {
      this.$store.commit("setChangepassshow", true);
      this.centerDialogVisible = false;
    },
    changeTab() {
      this.getCaptcha()
      // clearInterval(timer);
      // this.countdown = '发送验证码';
    },
    open() {
      this.centerDialogVisible = true;
    },
    // 切换注册
    registerChange() {
      this.centerDialogVisible = false;
      this.$register();
    },
    // 发送验证码{
    sendOutCode() {
      if (this.countdown.indexOf("倒计时") >= 0) return;
      this.sendOut();
      let time = 59;
      this.countdown = `倒计时（${time}）`;
      timer = setInterval(() => {
        time--;
        this.countdown = `倒计时（${time}）`;
        if (time < 1) {
          clearInterval(timer);
          this.countdown = `重新发送`;
        }
      }, 1000);
    },
    // 发送验证码请求
    sendOut() {
      postRequest({
        url: `/api/v1/user/sendsms?type=login&mobile=${this.dynamicValidateFormmobile.mobile}`,
      }).then((res) => {
        if (res.data) {
          this.$message.success("验证码已发送，请注意查收");
        } else {
          this.$message.error(res.errmsg);
        }
      });
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loginFunc(formName);
        } else {
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    // 登录
    loginFunc(formName) {
      let data = {};
      if (this.editableTabsValue == "1") {
        data = {
          code: "",
          password: this.dynamicValidateForm.pass,
          username: this.dynamicValidateForm.phoneEmail,
          captcha: this.dynamicValidateFormmobile.captcha,
        };
      } else if (this.editableTabsValue == "0") {
        data = {
          code: this.dynamicValidateFormmobile.mobilein,
          password: "",
          username: this.dynamicValidateFormmobile.mobile,
          captcha: this.dynamicValidateFormmobile.captcha,
        };
      }
      console.warn("this.$storethis.$store", this.$store);
      postRequest({
        url: "/security/login", data
      }).then((res) => {
        if (res.errcode == 200) {
          this.$emit("handleShow", { loginFlag: true });
          this.resetForm(formName);
          if (this.editableTabsValue == "1") {
            this.dynamicValidateForm.phoneEmail = "";
          }
          setJWT(res.data.token);
          setUSER(res.data.userPO);
          this.login && this.login(res.data);
          this.centerDialogVisible = false;
          this.$message.success("登录成功");
          location.reload();
        } else {
          this.$message.error(res.errmsg);
        }
      });
    },
  },
  created() {
    console.warn("你附近打开你的四", this);
  },
};
</script>
<style lang="scss" scoped>
.forget {
  display: flex;
  justify-content: space-between;
  align-items: center;

  .forget-pass {
    font-size: 14px;
    color: #165dff;
    line-height: 22px;
    cursor: pointer;
  }
}

.check {
  margin: 20px 0 12px 50px;
}

.newcheck {
  margin-left: 0;
}

::v-deep .el-checkbox,
::v-deep .el-checkbox__label {
  font-size: 12px;
}

::v-deep .el-checkbox__input.is-checked+.el-checkbox__label {
  color: #86909c;
}

.go {
  width: 100%;
  text-align: center;
  margin: 32px 0;
  font-size: 14px;
  color: #a9aeb8;
  line-height: 1.5;

  span {
    cursor: pointer;
  }
}

.el-radio {
  margin: 20px 50px 12px 0;
}

a {
  text-decoration: none;
}

.email {
  font-size: 14px;
  color: #4e5969;
  line-height: 1.5;
  margin-bottom: 6px;
  margin-top: 20px;
}

.regis {
  justify-content: space-between;
}

.register {
  display: flex;
  justify-content: space-between;
  line-height: 1.5;
  align-items: center;
  color: #1d2129;
  font-weight: bold;
  font-size: 30px;
  margin-bottom: 8px;

  > :last-child {
    cursor: pointer;
  }
}

::v-deep .el-dialog--center .el-dialog__body,
::v-deep .el-dialog__header {
  padding: 0;
}

::v-deep .el-radio__input.is-checked+.el-radio__label {
  color: #86909c !important;
}

::v-deep .el-form-item {
  margin-bottom: 12px !important;
}

::v-deep .el-radio__inner {
  width: 16px !important;
  height: 16px !important;
  border-radius: 2px 2px 2px 2px !important;
  border: 1px solid #e5e6eb !important;
}

::v-deep .el-input__inner {
  background: #f7f8fa !important;
  border: none !important;
  border-radius: 4px 4px 4px 4px !important;
}

// ::v-deep .el-tabs__header {
//     margin-bottom: 32px !important;
// }
::v-deep .el-tabs__active-bar {
  background-color: #165dff !important;
  height: 3px !important;
  border-top-left-radius: 2px !important;
  border-top-right-radius: 2px !important;
}

::v-deep .el-tabs__item.is-active {
  color: #165dff !important;
}

::v-deep .el-tabs__item {
  color: #4e5969 !important;
}

::v-deep .el-input-group__append,
.el-input-group__prepend {
  color: #165dff !important;
  border: none !important;
  margin: 0 15px !important;
}

::v-deep .el-input-group__append {
  padding-right: 15px !important;
}

::v-deep .el-tabs__nav-wrap::after {
  display: none !important;
}

::v-deep .el-radio__label {
  font-size: 12px !important;
}

::v-deep .el-dialog {
  width: 376px !important;
  // margin: 0 auto !important;
  padding: 32px 48px !important;
  background: #ffffff !important;
  border-radius: 12px !important;
}

.content {
  width: 100% !important;
  font-size: 14px !important;
}

.login {
  width: 376px !important;
  margin: 0 auto !important;
  padding: 32px 48px !important;
  background: #ffffff !important;
  border-radius: 12px !important;
}

.backg {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10;
  width: 100%;
  height: 100vh;
  background: rgba(29, 33, 41, 0.6000000238418579);
}
</style>
